import {
  API_ENDPOINT,
  useClientApiV1AccountsMyProfileUpdateMutation,
} from '../../resources/@types/accountSchema';

function useClientAccountMyProfileUpdateMutation(
  options?: Parameters<typeof useClientApiV1AccountsMyProfileUpdateMutation>[0]['options'],
) {
  return useClientApiV1AccountsMyProfileUpdateMutation({
    url: API_ENDPOINT.CLIENT_V1_ACCOUNTS_MY_PROFILE,
    options,
  });
}

export default useClientAccountMyProfileUpdateMutation;
